import axios from "axios";
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! Dropdown APIs
//TODO: Brand APIs
//  Brand
export const brandDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}brand-dd`, data, headers);
};
//TODO: Category APIs
//  Category
export const categoryDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}category-dd`, data, headers);
};
//TODO: Product Type APIs
//  Product Type
export const productTypeDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}product-type-dd`, data, headers);
};
//TODO: Specialization APIs

//  Specialization
export const specializationDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}specialization-dd`, data, headers);
};

//  Qualification
export const qualificationDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.get(`${BASE_URL}qualification-dd`, data, headers);
};
//  Qualification
export const getsubqualificationDDAPI = async (data) => {
  const headers = createHeaders(); 
  return await axios.post(`${BASE_URL}sub-qualification-dd`, data, headers);
};
export const departmentDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}department-dd`, data, headers);
};
//TODO: Ingredients APIs
//  Ingredients
export const ingredientsDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}ingredients-dd`, data, headers);
};
//TODO: Disease APIs
//  Disease
export const diseaseDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}disease-dd`, data, headers);
};
//TODO: Unit APIs
//  Unit
export const unitDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}unit-dd`, data, headers);
};
//TODO: Product APIs For Coupon Create
//  Product
export const productDDAPI = async (data) => {
  const headers = createHeaders(); 
  return await axios.get(`${BASE_URL}product-dd`, { params: data, headers: headers?.headers });
};
//TODO: User list APIs For Coupon Create
//  User list
export const userDDAPI = async (data) => {
  const headers = createHeaders(); 
  return await axios.post(`${BASE_URL}user-dd`, data,headers );
};
//TODO: State APIs For Coupon Create
//  State
export const stateDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}state-dd`, data, headers );
};
//TODO: District APIs For Coupon Create
//  District
export const districtDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}district-dd`, data, headers );
};
//TODO: Doctor DD APIs For Blog Create
//  Doctor
export const doctorDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}doctor-dd`, data, headers );
};
//  Diagnosis
export const diagnosisDDAPI = async (data) => {
  const headers = createHeaders();
  return await axios.post(`${BASE_URL}diagnosis-dd`, data, headers );
};
